import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ConfirmEmailForm from '../../containers/ConfirmEmail/ConfirmEmailForm';
import Message from '../../containers/Message/Message';

class ConfirmEmailPage extends Component {
  render() {
    return (
      <div>
        <Message />
          <div className="row" id="body">
            <div className="col">
              <div className="row justify-content-md-center mt-3">
                <div className="col-md-8 col-xl-6">
                  <ConfirmEmailForm location={ this.props.location } />
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  }
}

ConfirmEmailPage.propTypes = {
  location: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
  location: ownProps.location,
});

export default connect(mapStateToProps)(ConfirmEmailPage);